import * as React from 'react';
import { css } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Text } from '../../components';
import AuthPageWrap from './AuthPageWrap';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function AuthMessageWrap({ children }: Props) {
  return (
    <AuthPageWrap>
      <Text as="p" style={styles.message}>
        {children}
      </Text>
    </AuthPageWrap>
  );
}

const styles = css.create({
  message: {
    maxWidth: 380,
    color: color.neutral0,
    padding: 20,
    fontSize: 18,
    textAlign: 'center',
  },
});
